// singleton class for the services data http calls to the API

import { BaseService } from './base-service';
import { getHTTPHeaders } from '../helpers/utils';

class SuppliersService extends BaseService {
    constructor() {
        super();
    }

    getAllSuppliers(filterObj) {
        return new Promise((resolve, reject) => {
            let headersObj = getHTTPHeaders();
            this.$http.get(`suppliers/all?company_id=${filterObj.company_id}&area_id=${filterObj.area_id}&site_id=${filterObj.site_id}`, headersObj)
                .then((response) => {
                    resolve(response.data.suppliers);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    };

    getSuppliers(company_id) {
        return new Promise((resolve, reject) => {
            this.$http.get(`suppliers/${company_id}`, 
                getHTTPHeaders()
            )
                .then((response) => {
                    resolve(response.data.suppliers);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    // updateSupplier(company, id) {
    //     return new Promise((resolve, reject) => {
    //         this.$http.put(`company/${id}`, {
    //             company: company
    //           },
    //           getHTTPHeaders()
    //         )
    //             .then((response) => {
    //                 if (response.data.success == true) {
    //                     resolve();
    //                 }
    //                 else {
    //                     reject();
    //                 }
    //             })
    //             .catch ((err) => {
    //                 reject(err);
    //             });
    //     });
    // }

    // createSupplier(company) {
    //     return new Promise((resolve, reject) => {
    //         this.$http.post('company', {
    //             company: company
    //           },
    //           getHTTPHeaders()
    //         )
    //             .then((response) => {
    //                 if (response.data.success == true) {
    //                     resolve();
    //                 }
    //                 else {
    //                     reject();
    //                 }
    //             })
    //             .catch ((err) => {
    //                 reject(err);
    //             });
    //     });
    // }
}

export default new SuppliersService();